<script lang="ts">
    import { getContext, onDestroy } from 'svelte'
    import { derived as sderived } from 'svelte/store'
    import type { Readable } from 'svelte/store'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch, type SimpleFetchResult } from 'hydria/services/session'

    import type { AdminData, User, UserHandler } from './user'

    import CodeMirror from 'admin/components/CodeMirror.svelte'
    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'

    const userh = getContext('User') as UserHandler
    const user = sderived(userh.userWritable, ($v) => $v) as Readable<User>

    const loading = sderived(userh.loading, ($loading) => $loading)

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    const adata: Readable<AdminData> = sderived(userh.adminData, ($v) => $v)
    let saving: boolean = $state(false)

    // $: savedComment = $adata.comment == null ? '' : $adata.comment
    let savedComment = $state('')
    let editedComment = $state('')
    let dirty = $derived(savedComment != editedComment)

    async function save() {
        let r: SimpleFetchResult
        saving = true

        try {
            r = await simpleFetch('POST', `/json/wdom-user/1/${$user.id}/comment`, { comment: editedComment })
        } catch (e: any) {
            console.error('Failed to save comment:', e)
            r = e
            notify({
                type: 'danger',
                title: 'Commentaire',
                text: 'Le commentaire n’a pas pu être sauvegardé.',
            })
        }

        if (r && r.data) {
            userh.raw.user_admin_data.comment = r.data.comment
            // editedComment = savedComment
            userh.loadAdminData()
        }
        saving = false
    }

    unsubs.push(
        adata.subscribe(($adata) => {
            if ($adata == null) return

            if ($adata.comment != savedComment && (savedComment == editedComment || saving)) {
                savedComment = $adata.comment ? $adata.comment : ''
                editedComment = $adata.comment ? $adata.comment : ''
            } else if ($adata.comment != savedComment) {
                $adata.comment = savedComment
                notify({
                    type: 'warning',
                    title: 'Commentaire',
                    timeout: 20000,
                    text: 'Vous avez édité le commentaire, mais il aussi été changé à l’externe. Cliquez « Reset » pour ramener le nouveau commentaire. Sauvegarder à ce moment-ci va écraser les changements effectuées par un autre administrateur.',
                })
            }
        }),
    )
</script>

<div class="card">
    <div class="card-title text-primary">{$_('Comment')}</div>
    {#if $loading}
        <LoadingPattern pattern={['x', 'x']} />
    {:else}
        <div class="card-body">
            <CodeMirror options={{ theme: 'ttcn', lineWrapping: true, lineNumbers: true, readOnly: false, mode: 'plain' }} bind:value={editedComment} />
        </div>
    {/if}
    <div class="card-footer text-end text-bg-light">
        <button type="button" class="btn btn-outline-secondary" disabled={$loading || saving || !dirty} onclick={() => (editedComment = savedComment)}>{$_('Reset')}</button>
        <button type="button" class="btn" disabled={$loading || saving || !dirty} onclick={() => save()} class:btn-outline-secondary={!saving} class:btn-info={saving}>
            {#if saving}
                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                {$_('Saving…')}
            {:else}
                {$_('Save')}
            {/if}
        </button>
    </div>
</div>
